import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  xmlDiff: {
    overflowX: 'auto',
    maxWidth: '100%'
  },
  navBar: {
    position: 'sticky',
    top: 0,
    zIndex: 10,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    borderBottom: `1px solid ${theme.palette.divider}`,
    alignItems: 'center'
  },
  jumpToLabel: {
    marginRight: theme.spacing(1)
  },
  viewTabs: {
    flex: 1,
    minWidth: 0,
    marginBottom: theme.spacing(4),
    borderBottom: `1px solid ${theme.palette.divider}`
  },
  viewTabsContainer: {
    justifyContent: 'flex-start'
  },
  viewTab: {
    fontSize: 16
  }
}));
